import { getRoot, resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Duty } from './Duty';
import { PharmacyDetails } from './PharmacyDetails';

export const DutyAssignment = types.compose(
  BaseEntity,
  types
    .model('DutyAssignment', {
      dutyAssignmentId: types.identifierNumber,
      dutyId: types.number,
      pharmacyId: types.maybe(types.number),
      initialPharmacyId: types.maybe(types.number),
      exportedOn: types.maybeNull(types.string),
    })
    .views((self) => {
      return {
        get duty() {
          return resolveIdentifier(Duty, self, self.dutyId);
        },
        get pharmacyDetails() {
          if (self.pharmacyId) {
            return resolveIdentifier(PharmacyDetails, self, self.pharmacyId);
          } else {
            return null;
          }
        },
        get pharmacySimple() {
          if (self.pharmacyId) {
            const root: any = getRoot(self);
            return root.PharmacyStore.datas.get(self.pharmacyId);
          }
          return null;
        },
      };
    })
    .actions((self) => {
      return {};
    }),
);
